<div class="add-container">
    <h1 class="add-title">Adaugă modul locație activă</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Modul</mat-label>
                    <mat-select formControlName="id_modul">
                        <mat-option *ngFor="let row of modules$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_modul'].valid && form.controls['id_modul'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Locație</mat-label>
                    <mat-select formControlName="id_locatie">
                        <mat-option *ngFor="let row of locatii$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
				        !form.controls['id_locatie'].valid &&
				        form.controls['id_locatie'].touched
			        ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field>
                    <mat-label>Disponibilitate programare</mat-label>
                    <input matInput [matDatepicker]="dateStart" placeholder="Alegeți o dată"
                        formControlName="min_date_available" readonly (focus)="dateStart.open()" [min]="today">
                    <mat-datepicker-toggle matSuffix [for]="dateStart"></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                    <mat-error
                        *ngIf="!form.controls['min_date_available'].valid && form.controls['min_date_available'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field>
                    <mat-label>Ultima dată valabilă</mat-label>
                    <input matInput [matDatepicker]="dateEnd" placeholder="Alegeți o dată"
                        formControlName="max_date_available" readonly (focus)="dateEnd.open()" [min]="today">
                    <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                    <mat-error
                        *ngIf="!form.controls['max_date_available'].valid && form.controls['max_date_available'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
                <div class="mb-3">
                    <mat-error *ngIf="form.hasError('dateRange')">Ultima dată nu poate fi mai mică decât
                        data pentru disponibilitate programare</mat-error>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>